import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const WhatWeDoPage = () => {
  return <CMSPage pageType="what-we-do" />;
};

export default WhatWeDoPage;
